import React from 'react';

export default class UpdateDate extends React.Component {

  render() {
    return (
      <>
        令和8年9月15日
      </>
    );
  }

}